import React, { useState, useEffect } from "react";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { icons } from "../../assets/icons";

// Specify the location of the PDF.js worker script
export const CustomPdfViewer = ({ file }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfUrl, setPdfUrl] = useState(null);

  // const workerSrc = "https://keventers.corepeelers.com/static/pdfjs-dist/build/pdf/src/pdf.worker.js";
  
  
  useEffect(() => {
    if (file instanceof Blob) {
      const url = URL.createObjectURL(file);
      setPdfUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [file]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div className="h-full flex justify-center">
      {pdfUrl ? (
        <TransformWrapper
          initialPositionX={0}
          initialPositionY={0}
          onZoomStart={true}
        >
          {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
            <React.Fragment>
              <div className="flex items-center absolute top-[1rem] left-w-[100%] z-10 gap-x-3">
                <img
                  src={icons.zoomInIcon}
                  onClick={() => zoomIn()}
                  alt="zoom icon"
                  className="cursor-pointer"
                />
                <img
                  src={icons.zoomOutIcon}
                  onClick={() => zoomOut()}
                  alt="zoom icon"
                  className="cursor-pointer"
                />
              </div>
              <TransformComponent
                // contentClass="w-[100%] h-[100%]"
                // wrapperClass="w-[100%] h-[100%]"
                wrapperStyle={{height: '100%', width: '100%'}}
              >
                <div style={{
                    // height: "100%",
                    // width: "100%",
                    // objectFit: "contain",
                  }}>
                <Document
                  file={pdfUrl}
                  onLoadSuccess={onDocumentLoadSuccess}
                  className={"px-2 py-4"}
                >
                  {Array.from(new Array(numPages), (el, index) => (
                    <>
                      <p>
                        Page {index + 1} of {numPages}
                      </p>
                      <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        width={620}
                        scale={window.devicePixelRatio * 1}
                      />
                    </>
                  ))}
                </Document>
                </div>
              </TransformComponent>
            </React.Fragment>
          )}
        </TransformWrapper>
      ) : null}
    </div>
  );
};
